import { render, staticRenderFns } from "./PMVerifikasi.vue?vue&type=template&id=c245596c"
import script from "./PMVerifikasi.vue?vue&type=script&lang=js"
export * from "./PMVerifikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports